import { useSelector } from "react-redux"
import "./MultiplayerWPM.scss";
import { useEffect, useState } from "react";
import WPMLoader from "../WPMLoader/WPMLoader";
export default function MultiplayerWPM(){
    const { multiplayer_wpm } = useSelector(state => state.game);
    const [ wpm, setWPM ] = useState(multiplayer_wpm);
    const [ loaderFlag, setLoaderFlag ] = useState(false);
    const [ WPMFlag, setWPMFlag ] = useState(false);
    useEffect(()=> {
        if (multiplayer_wpm !== wpm){
            if ( multiplayer_wpm < wpm) {
                setWPMFlag(prevWPM => prevWPM = false);
            }
            else{
                setWPMFlag(prevWPM => prevWPM = true);
            }
            setWPM(prevWPM => prevWPM = multiplayer_wpm);
            setLoaderFlag(true);
        }
    },[wpm,multiplayer_wpm]);

    useEffect(()=>{
        let animate;
        if(loaderFlag === true){
            animate = setTimeout(() => {
                setLoaderFlag(false);
            }, 1300);
        }
        return () => clearTimeout(animate);
    },[loaderFlag])

    return(
        <div className="multiplayerWPM">
             <span>
                <u>
                Multiplayer WPM:&nbsp;
                </u>
                {loaderFlag ? 
                <WPMLoader
                higher={WPMFlag}
                />:
                <span> {Math.floor(multiplayer_wpm)} </span>
                }                
            </span>
        </div>
    )
}